import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

export const useQueryParams = () => {
  const [searchParams] = useSearchParams();
  return useMemo(() => Object.fromEntries(Array.from(searchParams)), [searchParams]);
};
